import { TFunction } from "i18next";
import * as Yup from "yup";

import { nullableAmount, nullableDate, nullableText } from "../../utils/validation.utils";
import { OwnClaimsMaxLength } from "./OwnClaimsView.types";

function createOwnClaimLimitsSchema(t: TFunction) {
  return Yup.object().shape({
    debtorName: nullableText(t, OwnClaimsMaxLength.debtorName),
    debtorAddress: nullableText(t, OwnClaimsMaxLength.debtorAddress),
    relationship: nullableText(t, OwnClaimsMaxLength.relationship),
    legalReason: nullableText(t, OwnClaimsMaxLength.legalReason),
    amount: nullableAmount(t),
    securities: nullableText(t, OwnClaimsMaxLength.text),
    disputeDetails: nullableText(t, OwnClaimsMaxLength.text),
    collectionSteps: nullableText(t, OwnClaimsMaxLength.text),
  });
}

export function createOwnClaimSchema(t: TFunction) {
  return createOwnClaimLimitsSchema(t).shape({
    dueDate: nullableDate(t),
  });
}

export function createOwnClaimsSchema(t: TFunction) {
  return Yup.object().shape({
    ownClaims: Yup.array().of(createOwnClaimLimitsSchema(t)),
  });
}
